import { Link } from "react-router-dom";
import { RiArrowRightLine } from "react-icons/ri";
import { IconContext } from "react-icons";

const options = {
    color: "white",
    size: "48px"
}

export default function Block({
    blockTopText,
    blockBottomText,
    blockPath
}) {
    return (
        <IconContext.Provider value={options}>
            <Link to={blockPath} className="w-1/3 lg:h-44 xl:h-48 flex justify-end items-center gap-48 px-8 border-r-8 relative transition-opacity duration-300 hover:opacity-100 opacity-70">
                <section className="w-full h-full absolute inset-x-0 transition-transform duration-200 hover:translate-x-8 flex items-center">
                    <RiArrowRightLine/>
                </section>
                <section className="flex flex-col gap-2 text-right">
                    <p className="text-slate-400 lg:text-lg xl:text-xl">{blockTopText}</p>
                    <h3 className="text-white lg:text-3xl xl:text-4xl">{blockBottomText}</h3>
                </section>
            </Link>
        </IconContext.Provider>
    )
}